import { ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { shouldUseDsoStructure } from '~/growthbook';
import { useAppSelector } from '~/hooks/useAppSelector';

interface IProps {
  children: ReactNode;
  customCondition?: boolean;
}

export const NotAllowedGuard = ({ children, customCondition }: IProps) => {
  const navigate = useNavigate();
  const selectedOfficeId = useAppSelector((state) => state.user.selectedOfficeId);

  useEffect(() => {
    if (customCondition || (shouldUseDsoStructure() && !selectedOfficeId)) {
      navigate('/', { state: { showNotAllowedPopup: true } });
    }
  }, [selectedOfficeId, navigate, customCondition]);

  if (shouldUseDsoStructure() && !selectedOfficeId) {
    return <></>;
  }

  return <>{children}</>;
};
